import gql from 'graphql-tag';

// Only used for a full ShineStartDocument and not limited information
// loaded for the list of all documents
export const shineStartDocumentFragment = gql`
  fragment ShineStartDocument on ShineStartDocument {
    shineStartDocumentId
    shineStartId
    error
    errorLocalized
    status
    type
    typeLocalized
    url
    updatedAt
  }
`;
